module.exports = __webpack_public_path__ + "img/Pagsmile Brasil_SVITI_Certificate 20221221-1.1d533a9.png";